var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "tuition-stat-v3" },
    [
      _c("div", { staticClass: "stat-section-header" }, [
        _vm._m(0),
        _c("div", { staticClass: "header-filters" }, [
          _c("div", { staticClass: "filter-mode-tabs" }, [
            _c(
              "button",
              {
                class: ["mode-tab-btn", { active: _vm.filterMode === "month" }],
                attrs: { type: "button" },
                on: {
                  click: function ($event) {
                    return _vm.setFilterMode("month")
                  },
                },
              },
              [
                _c("i", { staticClass: "el-icon-date" }),
                _vm._v(" Theo Tháng\n        "),
              ]
            ),
            _c(
              "button",
              {
                class: ["mode-tab-btn", { active: _vm.filterMode === "range" }],
                attrs: { type: "button" },
                on: {
                  click: function ($event) {
                    return _vm.setFilterMode("range")
                  },
                },
              },
              [
                _c("i", { staticClass: "el-icon-time" }),
                _vm._v(" Theo Khoảng Thời Gian\n        "),
              ]
            ),
          ]),
          _c(
            "div",
            { staticClass: "picker-container" },
            [
              _vm.filterMode === "month"
                ? _c("el-date-picker", {
                    key: "tuition-month-picker",
                    staticClass: "month-picker",
                    attrs: {
                      type: "month",
                      size: "small",
                      format: "MM/yyyy",
                      "value-format": "yyyy-MM",
                      placeholder: "Chọn tháng",
                      clearable: false,
                    },
                    on: { change: _vm.handleFilterChange },
                    model: {
                      value: _vm.selectedMonth,
                      callback: function ($$v) {
                        _vm.selectedMonth = $$v
                      },
                      expression: "selectedMonth",
                    },
                  })
                : _c("el-date-picker", {
                    key: "tuition-month-range-picker",
                    staticClass: "range-picker",
                    attrs: {
                      type: "monthrange",
                      size: "small",
                      format: "MM/yyyy",
                      "value-format": "yyyy-MM",
                      "range-separator": "-",
                      "start-placeholder": "Từ tháng",
                      "end-placeholder": "Đến tháng",
                      clearable: false,
                    },
                    on: { change: _vm.handleFilterChange },
                    model: {
                      value: _vm.selectedDateRange,
                      callback: function ($$v) {
                        _vm.selectedDateRange = $$v
                      },
                      expression: "selectedDateRange",
                    },
                  }),
            ],
            1
          ),
          _c(
            "div",
            { staticClass: "grade-filter-box" },
            [
              _c(
                "el-select",
                {
                  staticClass: "grade-select",
                  attrs: {
                    size: "small",
                    placeholder: "Tất cả các khối",
                    clearable: "",
                  },
                  on: { change: _vm.handleGradeChange },
                  model: {
                    value: _vm.selectedGrade,
                    callback: function ($$v) {
                      _vm.selectedGrade = $$v
                    },
                    expression: "selectedGrade",
                  },
                },
                _vm._l(_vm.gradeOptions, function (g) {
                  return _c("el-option", {
                    key: g.value,
                    attrs: { label: g.label, value: g.value },
                  })
                }),
                1
              ),
            ],
            1
          ),
        ]),
      ]),
      _vm.loading
        ? _c("el-alert", {
            staticClass: "tuition-state-alert",
            attrs: {
              title: "Đang tải thống kê học phí...",
              type: "info",
              closable: false,
              "show-icon": "",
            },
          })
        : _vm.errorMessage
        ? _c("el-alert", {
            staticClass: "tuition-state-alert",
            attrs: {
              title: _vm.errorMessage,
              type: "error",
              closable: false,
              "show-icon": "",
            },
          })
        : _vm.noData
        ? _c("el-alert", {
            staticClass: "tuition-state-alert",
            attrs: {
              title: "Không có dữ liệu học phí trong kỳ đã chọn.",
              type: "info",
              closable: false,
              "show-icon": "",
            },
          })
        : _vm._e(),
      !_vm.loading && !_vm.errorMessage && !_vm.noData
        ? [
            _c("div", { staticClass: "tuition-kpi-grid" }, [
              _c("div", { staticClass: "tuition-kpi-card kpi-receivable" }, [
                _vm._m(1),
                _c("div", { staticClass: "kpi-body" }, [
                  _vm._m(2),
                  _c("div", { staticClass: "kpi-value-row" }, [
                    _c("strong", { staticClass: "kpi-amount text-blue-dark" }, [
                      _vm._v(
                        _vm._s(
                          _vm.formatMoney(_vm.selectedSummary.totalReceivable)
                        )
                      ),
                    ]),
                  ]),
                  _c("div", { staticClass: "kpi-meta-text" }, [
                    _c("span", [
                      _c("i", { staticClass: "el-icon-document" }),
                      _c("b", [
                        _vm._v(_vm._s(_vm.selectedSummary.kidsTotalNumber)),
                      ]),
                      _vm._v(" học sinh trong roster kỳ"),
                    ]),
                  ]),
                ]),
              ]),
              _c("div", { staticClass: "tuition-kpi-card kpi-paid" }, [
                _vm._m(3),
                _c("div", { staticClass: "kpi-body" }, [
                  _c("div", { staticClass: "kpi-top-row" }, [
                    _c("span", { staticClass: "kpi-label" }, [
                      _vm._v("Tổng Đã Thu"),
                    ]),
                    _c("span", { staticClass: "kpi-tag tag-emerald" }, [
                      _vm._v("Đạt " + _vm._s(_vm.collectionRate) + "%"),
                    ]),
                  ]),
                  _c("div", { staticClass: "kpi-value-row" }, [
                    _c("strong", { staticClass: "kpi-amount text-emerald" }, [
                      _vm._v(
                        _vm._s(_vm.formatMoney(_vm.selectedSummary.totalPaid))
                      ),
                    ]),
                  ]),
                  _c("div", { staticClass: "kpi-progress-bar" }, [
                    _c("div", {
                      staticClass: "kpi-progress-fill fill-emerald",
                      style: { width: _vm.collectionProgressWidth + "%" },
                    }),
                  ]),
                  _c("div", { staticClass: "kpi-meta-text" }, [
                    _c("span", [
                      _c("i", { staticClass: "el-icon-check" }),
                      _c("b", [
                        _vm._v(_vm._s(_vm.selectedSummary.completedStudents)),
                      ]),
                      _vm._v(" học sinh đã hoàn tất đóng phí"),
                    ]),
                  ]),
                ]),
              ]),
              _c("div", { staticClass: "tuition-kpi-card kpi-remaining" }, [
                _vm._m(4),
                _c("div", { staticClass: "kpi-body" }, [
                  _c("div", { staticClass: "kpi-top-row" }, [
                    _c("span", { staticClass: "kpi-label" }, [
                      _vm._v("Tổng Còn Lại (Công nợ)"),
                    ]),
                    _c("span", { staticClass: "kpi-tag tag-rose" }, [
                      _vm._v("Còn " + _vm._s(_vm.remainingRate) + "%"),
                    ]),
                  ]),
                  _c("div", { staticClass: "kpi-value-row" }, [
                    _c("strong", { staticClass: "kpi-amount text-rose" }, [
                      _vm._v(
                        _vm._s(
                          _vm.formatMoney(_vm.selectedSummary.totalRemaining)
                        )
                      ),
                    ]),
                  ]),
                  _c("div", { staticClass: "kpi-progress-bar" }, [
                    _c("div", {
                      staticClass: "kpi-progress-fill fill-rose",
                      style: { width: _vm.remainingProgressWidth + "%" },
                    }),
                  ]),
                  _c("div", { staticClass: "kpi-meta-text" }, [
                    _c("span", [
                      _c("i", { staticClass: "el-icon-time" }),
                      _c("b", [
                        _vm._v(_vm._s(_vm.selectedSummary.pendingStudents)),
                      ]),
                      _vm._v(" học sinh cần đôn đốc nộp bổ sung"),
                    ]),
                  ]),
                ]),
              ]),
            ]),
            _c("div", { staticClass: "status-summary-strip" }, [
              _c("div", { staticClass: "strip-header" }, [
                _vm._m(5),
                _c("span", { staticClass: "strip-count-text" }, [
                  _vm._v("\n        Tổng số học sinh xét duyệt: "),
                  _c("b", [
                    _vm._v(_vm._s(_vm.selectedSummary.kidsTotalNumber) + " HS"),
                  ]),
                ]),
              ]),
              _c("div", { staticClass: "status-chips-grid" }, [
                _c("div", { staticClass: "status-chip-card chip-unbilled" }, [
                  _vm._m(6),
                  _c("div", { staticClass: "chip-count" }, [
                    _c("b", [_vm._v(_vm._s(_vm.selectedSummary.unbilled))]),
                    _c("span", { staticClass: "unit" }, [_vm._v("HS")]),
                    _c("span", { staticClass: "pct" }, [
                      _vm._v(
                        "(" + _vm._s(_vm.selectedSummary.unbilledRate) + "%)"
                      ),
                    ]),
                  ]),
                ]),
                _c("div", { staticClass: "status-chip-card chip-unpaid" }, [
                  _vm._m(7),
                  _c("div", { staticClass: "chip-count" }, [
                    _c("b", { staticClass: "text-rose" }, [
                      _vm._v(_vm._s(_vm.selectedSummary.unpaid)),
                    ]),
                    _c("span", { staticClass: "unit" }, [_vm._v("HS")]),
                    _c("span", { staticClass: "pct" }, [
                      _vm._v(
                        "(" + _vm._s(_vm.selectedSummary.unpaidRate) + "%)"
                      ),
                    ]),
                  ]),
                ]),
                _c("div", { staticClass: "status-chip-card chip-partial" }, [
                  _vm._m(8),
                  _c("div", { staticClass: "chip-count" }, [
                    _c("b", { staticClass: "text-amber" }, [
                      _vm._v(_vm._s(_vm.selectedSummary.partiallyPaid)),
                    ]),
                    _c("span", { staticClass: "unit" }, [_vm._v("HS")]),
                    _c("span", { staticClass: "pct" }, [
                      _vm._v(
                        "(" +
                          _vm._s(_vm.selectedSummary.partiallyPaidRate) +
                          "%)"
                      ),
                    ]),
                  ]),
                ]),
                _c("div", { staticClass: "status-chip-card chip-full" }, [
                  _vm._m(9),
                  _c("div", { staticClass: "chip-count" }, [
                    _c("b", { staticClass: "text-emerald" }, [
                      _vm._v(_vm._s(_vm.selectedSummary.fullyPaid)),
                    ]),
                    _c("span", { staticClass: "unit" }, [_vm._v("HS")]),
                    _c("span", { staticClass: "pct" }, [
                      _vm._v(
                        "(" + _vm._s(_vm.selectedSummary.fullyPaidRate) + "%)"
                      ),
                    ]),
                  ]),
                ]),
                _c("div", { staticClass: "status-chip-card chip-overpaid" }, [
                  _vm._m(10),
                  _c("div", { staticClass: "chip-count" }, [
                    _c("b", { staticClass: "text-purple" }, [
                      _vm._v(_vm._s(_vm.selectedSummary.overpaid)),
                    ]),
                    _c("span", { staticClass: "unit" }, [_vm._v("HS")]),
                    _c("span", { staticClass: "pct" }, [
                      _vm._v(
                        "(" + _vm._s(_vm.selectedSummary.overpaidRate) + "%)"
                      ),
                    ]),
                  ]),
                ]),
                _c("div", { staticClass: "status-chip-card chip-surplus" }, [
                  _vm._m(11),
                  _c("div", { staticClass: "chip-count" }, [
                    _c("b", { staticClass: "text-teal" }, [
                      _vm._v(_vm._s(_vm.selectedSummary.fullyPaidWithSurplus)),
                    ]),
                    _c("span", { staticClass: "unit" }, [_vm._v("HS")]),
                    _c("span", { staticClass: "pct" }, [
                      _vm._v(
                        "(" +
                          _vm._s(_vm.selectedSummary.fullyPaidWithSurplusRate) +
                          "%)"
                      ),
                    ]),
                  ]),
                ]),
                _c("div", { staticClass: "status-chip-card chip-deficit" }, [
                  _vm._m(12),
                  _c("div", { staticClass: "chip-count" }, [
                    _c("b", { staticClass: "text-indigo" }, [
                      _vm._v(_vm._s(_vm.selectedSummary.paidWithDeficit)),
                    ]),
                    _c("span", { staticClass: "unit" }, [_vm._v("HS")]),
                    _c("span", { staticClass: "pct" }, [
                      _vm._v(
                        "(" +
                          _vm._s(_vm.selectedSummary.paidWithDeficitRate) +
                          "%)"
                      ),
                    ]),
                  ]),
                ]),
              ]),
            ]),
            _c(
              "el-row",
              { staticClass: "charts-row", attrs: { gutter: 20 } },
              [
                _c("el-col", { attrs: { xs: 24, sm: 24, md: 14, lg: 14 } }, [
                  _c("div", { staticClass: "chart-card h-100" }, [
                    _c("div", { staticClass: "chart-card-head" }, [
                      _c("div", [
                        _c("h3", { staticClass: "chart-title" }, [
                          _vm._v("Tiến Độ Thu Học Phí Theo Khối Lớp"),
                        ]),
                        _c("p", { staticClass: "chart-subtitle" }, [
                          _vm._v(
                            "So sánh số tiền thực tế đã thu và công nợ còn lại theo khối"
                          ),
                        ]),
                      ]),
                      _c("div", { staticClass: "tuition-chart-legend" }, [
                        _c("span", { staticClass: "tuition-legend-item" }, [
                          _c("span", {
                            staticClass:
                              "tuition-legend-color tuition-legend-color--paid",
                          }),
                          _vm._v(" Đã thu"),
                        ]),
                        _c("span", { staticClass: "tuition-legend-item" }, [
                          _c("span", {
                            staticClass:
                              "tuition-legend-color tuition-legend-color--remaining",
                          }),
                          _vm._v(" Còn lại"),
                        ]),
                      ]),
                    ]),
                    _c("div", {
                      ref: "chartTuitionGradeProgress",
                      staticClass: "chart-container",
                    }),
                  ]),
                ]),
                _c("el-col", { attrs: { xs: 24, sm: 24, md: 10, lg: 10 } }, [
                  _c("div", { staticClass: "chart-card h-100" }, [
                    _c("div", { staticClass: "chart-card-head" }, [
                      _c("div", [
                        _c("h3", { staticClass: "chart-title" }, [
                          _vm._v("Cơ Cấu Trạng Thái Phiếu Thu"),
                        ]),
                        _c("p", { staticClass: "chart-subtitle" }, [
                          _vm._v(
                            "Tỷ trọng 7 trạng thái đóng học phí trong phạm vi khối đã chọn"
                          ),
                        ]),
                      ]),
                      _c(
                        "span",
                        { staticClass: "badge-soft badge-soft--blue" },
                        [_vm._v("7 trạng thái")]
                      ),
                    ]),
                    _c("div", {
                      ref: "chartTuitionStatusDonut",
                      staticClass: "chart-container",
                    }),
                  ]),
                ]),
              ],
              1
            ),
            _c(
              "div",
              { staticClass: "class-tuition-section" },
              [
                _c(
                  "div",
                  {
                    class: [
                      "class-tuition-head",
                      { "is-expanded": _vm.showClassTable },
                    ],
                  },
                  [
                    _vm._m(13),
                    _c(
                      "div",
                      { staticClass: "class-tuition-actions" },
                      [
                        _c("span", { staticClass: "counter-badge" }, [
                          _c("i", { staticClass: "el-icon-school" }),
                          _vm._v(
                            " " +
                              _vm._s(_vm.filteredClassList.length) +
                              " Lớp\n        "
                          ),
                        ]),
                        _c(
                          "el-button",
                          {
                            staticClass: "table-toggle-btn",
                            attrs: {
                              size: "small",
                              type: "primary",
                              plain: "",
                            },
                            on: {
                              click: function ($event) {
                                _vm.showClassTable = !_vm.showClassTable
                              },
                            },
                          },
                          [
                            _c("i", {
                              class: _vm.showClassTable
                                ? "el-icon-arrow-up"
                                : "el-icon-arrow-down",
                            }),
                            _vm._v(
                              "\n          " +
                                _vm._s(
                                  _vm.showClassTable
                                    ? "Thu gọn bảng"
                                    : "Xem chi tiết bảng"
                                ) +
                                "\n        "
                            ),
                          ]
                        ),
                      ],
                      1
                    ),
                  ]
                ),
                _c("el-collapse-transition", [
                  _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.showClassTable,
                          expression: "showClassTable",
                        },
                      ],
                      staticClass: "class-tuition-collapsible-body",
                    },
                    [
                      _c(
                        "div",
                        { staticClass: "class-tuition-search-wrap" },
                        [
                          _c("el-input", {
                            staticClass: "table-search-input",
                            attrs: {
                              size: "small",
                              placeholder: "Tìm theo tên lớp...",
                              "prefix-icon": "el-icon-search",
                              clearable: "",
                            },
                            model: {
                              value: _vm.tableSearchQuery,
                              callback: function ($$v) {
                                _vm.tableSearchQuery = $$v
                              },
                              expression: "tableSearchQuery",
                            },
                          }),
                        ],
                        1
                      ),
                      _c(
                        "div",
                        { staticClass: "class-tuition-table-wrap" },
                        [
                          _c(
                            "el-table",
                            {
                              staticClass: "modern-tuition-table",
                              attrs: {
                                data: _vm.filteredClassList,
                                stripe: "",
                                border: "",
                                size: "small",
                                "max-height": "500",
                                "empty-text":
                                  "Không tìm thấy lớp học nào phù hợp",
                                "show-summary": "",
                                "summary-method": _vm.getCustomTableSummaries,
                              },
                            },
                            [
                              _c("el-table-column", {
                                attrs: {
                                  type: "index",
                                  label: "STT",
                                  width: "50",
                                  align: "center",
                                  fixed: "left",
                                },
                              }),
                              _c("el-table-column", {
                                attrs: {
                                  label: "Lớp Học & Khối",
                                  "min-width": "160",
                                  fixed: "left",
                                },
                                scopedSlots: _vm._u(
                                  [
                                    {
                                      key: "default",
                                      fn: function (scope) {
                                        return [
                                          _c(
                                            "div",
                                            { staticClass: "class-cell-meta" },
                                            [
                                              _c(
                                                "strong",
                                                {
                                                  staticClass: "class-name-txt",
                                                },
                                                [
                                                  _vm._v(
                                                    _vm._s(scope.row.className)
                                                  ),
                                                ]
                                              ),
                                              _c(
                                                "span",
                                                {
                                                  staticClass: "grade-pill",
                                                  class:
                                                    "pill-" + scope.row.gradeId,
                                                },
                                                [
                                                  _vm._v(
                                                    _vm._s(scope.row.gradeName)
                                                  ),
                                                ]
                                              ),
                                            ]
                                          ),
                                        ]
                                      },
                                    },
                                  ],
                                  null,
                                  false,
                                  4071677440
                                ),
                              }),
                              _c("el-table-column", {
                                attrs: {
                                  label: "Sĩ Số",
                                  prop: "kidsTotalNumber",
                                  width: "75",
                                  align: "center",
                                },
                                scopedSlots: _vm._u(
                                  [
                                    {
                                      key: "default",
                                      fn: function (scope) {
                                        return [
                                          _c(
                                            "span",
                                            {
                                              staticClass:
                                                "student-count-badge",
                                            },
                                            [
                                              _vm._v(
                                                _vm._s(
                                                  scope.row.kidsTotalNumber
                                                )
                                              ),
                                            ]
                                          ),
                                        ]
                                      },
                                    },
                                  ],
                                  null,
                                  false,
                                  2944052507
                                ),
                              }),
                              _c("el-table-column", {
                                attrs: {
                                  label: "Chưa Có Phiếu",
                                  prop: "unbilled",
                                  width: "105",
                                  align: "center",
                                },
                                scopedSlots: _vm._u(
                                  [
                                    {
                                      key: "default",
                                      fn: function (scope) {
                                        return [
                                          _c(
                                            "span",
                                            {
                                              class:
                                                scope.row.unbilled > 0
                                                  ? "badge-st badge-unbilled"
                                                  : "badge-st badge-zero",
                                            },
                                            [
                                              _vm._v(
                                                "\n              " +
                                                  _vm._s(scope.row.unbilled) +
                                                  "\n            "
                                              ),
                                            ]
                                          ),
                                        ]
                                      },
                                    },
                                  ],
                                  null,
                                  false,
                                  912285664
                                ),
                              }),
                              _c("el-table-column", {
                                attrs: {
                                  label: "Chưa Đóng 100%",
                                  prop: "unpaid",
                                  width: "115",
                                  align: "center",
                                },
                                scopedSlots: _vm._u(
                                  [
                                    {
                                      key: "default",
                                      fn: function (scope) {
                                        return [
                                          _c(
                                            "span",
                                            {
                                              class:
                                                scope.row.unpaid > 0
                                                  ? "badge-st badge-unpaid"
                                                  : "badge-st badge-zero",
                                            },
                                            [
                                              _vm._v(
                                                "\n              " +
                                                  _vm._s(scope.row.unpaid) +
                                                  "\n            "
                                              ),
                                            ]
                                          ),
                                        ]
                                      },
                                    },
                                  ],
                                  null,
                                  false,
                                  324382198
                                ),
                              }),
                              _c("el-table-column", {
                                attrs: {
                                  label: "Chưa Đóng Đủ",
                                  prop: "partiallyPaid",
                                  width: "110",
                                  align: "center",
                                },
                                scopedSlots: _vm._u(
                                  [
                                    {
                                      key: "default",
                                      fn: function (scope) {
                                        return [
                                          _c(
                                            "span",
                                            {
                                              class:
                                                scope.row.partiallyPaid > 0
                                                  ? "badge-st badge-partial"
                                                  : "badge-st badge-zero",
                                            },
                                            [
                                              _vm._v(
                                                "\n              " +
                                                  _vm._s(
                                                    scope.row.partiallyPaid
                                                  ) +
                                                  "\n            "
                                              ),
                                            ]
                                          ),
                                        ]
                                      },
                                    },
                                  ],
                                  null,
                                  false,
                                  295607810
                                ),
                              }),
                              _c("el-table-column", {
                                attrs: {
                                  label: "Đóng Đủ 100%",
                                  prop: "fullyPaid",
                                  width: "115",
                                  align: "center",
                                },
                                scopedSlots: _vm._u(
                                  [
                                    {
                                      key: "default",
                                      fn: function (scope) {
                                        return [
                                          _c(
                                            "span",
                                            {
                                              staticClass:
                                                "badge-st badge-fully-paid",
                                            },
                                            [
                                              _vm._v(
                                                "\n              " +
                                                  _vm._s(scope.row.fullyPaid) +
                                                  "\n            "
                                              ),
                                            ]
                                          ),
                                        ]
                                      },
                                    },
                                  ],
                                  null,
                                  false,
                                  3430633642
                                ),
                              }),
                              _c("el-table-column", {
                                attrs: {
                                  label: "Đóng Thừa",
                                  prop: "overpaid",
                                  width: "95",
                                  align: "center",
                                },
                                scopedSlots: _vm._u(
                                  [
                                    {
                                      key: "default",
                                      fn: function (scope) {
                                        return [
                                          _c(
                                            "span",
                                            {
                                              class:
                                                scope.row.overpaid > 0
                                                  ? "badge-st badge-overpaid"
                                                  : "badge-st badge-zero",
                                            },
                                            [
                                              _vm._v(
                                                "\n              " +
                                                  _vm._s(scope.row.overpaid) +
                                                  "\n            "
                                              ),
                                            ]
                                          ),
                                        ]
                                      },
                                    },
                                  ],
                                  null,
                                  false,
                                  877649251
                                ),
                              }),
                              _c("el-table-column", {
                                attrs: {
                                  label: "Đóng Đủ Thừa",
                                  prop: "fullyPaidWithSurplus",
                                  width: "110",
                                  align: "center",
                                },
                                scopedSlots: _vm._u(
                                  [
                                    {
                                      key: "default",
                                      fn: function (scope) {
                                        return [
                                          _c(
                                            "span",
                                            {
                                              class:
                                                scope.row.fullyPaidWithSurplus >
                                                0
                                                  ? "badge-st badge-surplus"
                                                  : "badge-st badge-zero",
                                            },
                                            [
                                              _vm._v(
                                                "\n              " +
                                                  _vm._s(
                                                    scope.row
                                                      .fullyPaidWithSurplus
                                                  ) +
                                                  "\n            "
                                              ),
                                            ]
                                          ),
                                        ]
                                      },
                                    },
                                  ],
                                  null,
                                  false,
                                  1471277727
                                ),
                              }),
                              _c("el-table-column", {
                                attrs: {
                                  label: "Đóng Đủ Thiếu",
                                  prop: "paidWithDeficit",
                                  width: "110",
                                  align: "center",
                                },
                                scopedSlots: _vm._u(
                                  [
                                    {
                                      key: "default",
                                      fn: function (scope) {
                                        return [
                                          _c(
                                            "span",
                                            {
                                              class:
                                                scope.row.paidWithDeficit > 0
                                                  ? "badge-st badge-deficit"
                                                  : "badge-st badge-zero",
                                            },
                                            [
                                              _vm._v(
                                                "\n              " +
                                                  _vm._s(
                                                    scope.row.paidWithDeficit
                                                  ) +
                                                  "\n            "
                                              ),
                                            ]
                                          ),
                                        ]
                                      },
                                    },
                                  ],
                                  null,
                                  false,
                                  762635841
                                ),
                              }),
                              _c("el-table-column", {
                                attrs: {
                                  label: "Phải Thu",
                                  prop: "totalReceivable",
                                  "min-width": "125",
                                  align: "right",
                                },
                                scopedSlots: _vm._u(
                                  [
                                    {
                                      key: "default",
                                      fn: function (scope) {
                                        return [
                                          _c(
                                            "span",
                                            {
                                              staticClass:
                                                "money-cell text-slate-dark",
                                            },
                                            [
                                              _vm._v(
                                                _vm._s(
                                                  _vm.formatMoney(
                                                    scope.row.totalReceivable
                                                  )
                                                )
                                              ),
                                            ]
                                          ),
                                        ]
                                      },
                                    },
                                  ],
                                  null,
                                  false,
                                  1964647233
                                ),
                              }),
                              _c("el-table-column", {
                                attrs: {
                                  label: "Đã Thu",
                                  prop: "totalPaid",
                                  "min-width": "125",
                                  align: "right",
                                },
                                scopedSlots: _vm._u(
                                  [
                                    {
                                      key: "default",
                                      fn: function (scope) {
                                        return [
                                          _c(
                                            "strong",
                                            {
                                              staticClass:
                                                "money-cell text-emerald",
                                            },
                                            [
                                              _vm._v(
                                                _vm._s(
                                                  _vm.formatMoney(
                                                    scope.row.totalPaid
                                                  )
                                                )
                                              ),
                                            ]
                                          ),
                                        ]
                                      },
                                    },
                                  ],
                                  null,
                                  false,
                                  592643470
                                ),
                              }),
                              _c("el-table-column", {
                                attrs: {
                                  label: "Còn Lại",
                                  prop: "totalRemaining",
                                  "min-width": "120",
                                  align: "right",
                                },
                                scopedSlots: _vm._u(
                                  [
                                    {
                                      key: "default",
                                      fn: function (scope) {
                                        return [
                                          _c(
                                            "strong",
                                            {
                                              staticClass:
                                                "money-cell text-rose",
                                            },
                                            [
                                              _vm._v(
                                                _vm._s(
                                                  _vm.formatMoney(
                                                    scope.row.totalRemaining
                                                  )
                                                )
                                              ),
                                            ]
                                          ),
                                        ]
                                      },
                                    },
                                  ],
                                  null,
                                  false,
                                  2020965523
                                ),
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ]
                  ),
                ]),
              ],
              1
            ),
          ]
        : _vm._e(),
    ],
    2
  )
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "header-left" }, [
      _c("div", { staticClass: "section-icon-badge" }, [
        _c("i", { staticClass: "el-icon-wallet" }),
      ]),
      _c("div", [
        _c("div", { staticClass: "title-with-pill" }, [
          _c("h2", { staticClass: "section-main-title" }, [
            _vm._v("Thống Kê Học Phí & Khoản Thu"),
          ]),
          _c("span", { staticClass: "live-status-pill" }, [
            _c("span", { staticClass: "pulse-dot" }),
            _vm._v(" Dữ liệu học phí\n          "),
          ]),
        ]),
        _c("p", { staticClass: "section-subtitle" }, [
          _vm._v(
            "\n          Theo dõi tổng nguồn thu, tiến độ đóng học phí và phân loại 7 trạng thái phiếu thu của từng lớp\n        "
          ),
        ]),
      ]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c(
      "div",
      { staticClass: "kpi-icon-wrap bg-blue-subtle text-blue" },
      [_c("i", { staticClass: "el-icon-wallet" })]
    )
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "kpi-top-row" }, [
      _c("span", { staticClass: "kpi-label" }, [_vm._v("Tổng Phải Thu")]),
      _c("span", { staticClass: "kpi-tag tag-blue" }, [_vm._v("Kế hoạch")]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c(
      "div",
      { staticClass: "kpi-icon-wrap bg-emerald-subtle text-emerald" },
      [_c("i", { staticClass: "el-icon-circle-check" })]
    )
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c(
      "div",
      { staticClass: "kpi-icon-wrap bg-rose-subtle text-rose" },
      [_c("i", { staticClass: "el-icon-warning-outline" })]
    )
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("span", { staticClass: "strip-title" }, [
      _c("i", { staticClass: "el-icon-pie-chart" }),
      _vm._v(" Phân Bổ 7 Trạng Thái Đóng Học Phí\n      "),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "chip-top" }, [
      _c("span", { staticClass: "status-dot dot-gray" }),
      _c("span", { staticClass: "status-name" }, [_vm._v("Chưa có phiếu thu")]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "chip-top" }, [
      _c("span", { staticClass: "status-dot dot-rose" }),
      _c("span", { staticClass: "status-name" }, [_vm._v("Chưa đóng 100%")]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "chip-top" }, [
      _c("span", { staticClass: "status-dot dot-amber" }),
      _c("span", { staticClass: "status-name" }, [_vm._v("Chưa đóng đủ")]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "chip-top" }, [
      _c("span", { staticClass: "status-dot dot-emerald" }),
      _c("span", { staticClass: "status-name" }, [_vm._v("Đóng đủ 100%")]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "chip-top" }, [
      _c("span", { staticClass: "status-dot dot-purple" }),
      _c("span", { staticClass: "status-name" }, [_vm._v("Đóng thừa")]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "chip-top" }, [
      _c("span", { staticClass: "status-dot dot-teal" }),
      _c("span", { staticClass: "status-name" }, [_vm._v("Đóng đủ thừa")]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "chip-top" }, [
      _c("span", { staticClass: "status-dot dot-indigo" }),
      _c("span", { staticClass: "status-name" }, [_vm._v("Đóng đủ thiếu")]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "class-tuition-title-group" }, [
      _c("div", { staticClass: "section-icon-badge sub-icon" }, [
        _c("i", { staticClass: "el-icon-s-grid" }),
      ]),
      _c("div", [
        _c("h3", { staticClass: "section-heading" }, [
          _vm._v("Thống Kê Chỉ Số Đóng Học Phí Theo Từng Lớp"),
        ]),
        _c("p", { staticClass: "section-subheading" }, [
          _vm._v(
            "\n            Chi tiết số lượng học sinh theo 7 trạng thái thu học phí và số tiền phải thu, đã thu, còn lại\n          "
          ),
        ]),
      ]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }